const routes = {
  createRole: 'roles/add',
  getRoles: 'roles',
  updateRole: 'roles/update',
  deleteRole: 'roles/delete',
  getRolesPermissions: 'permissions',
  updateRolesPermissions: 'permissions/update',
  getSubRolesPermissions:'permissions/subUser'
};

export default routes